export default [
  {
    path: '/homepage',
    component: resolve => require(['./Homepage.vue'], resolve),
    name: 'homepage',
    leaf: true//只有一个节点
  }
]
